import { uploadPath } from '@/config'

const state = {
	messages: [],
	contacts: [],
	favorites: [],
	conversations: [],
	selectedConversation: {}
}

const mutations = {
	updateConversation: (state, conversation) => {
		let foundedConversationIndex = state.conversations.findIndex(c => c.id === conversation.id)
		if (foundedConversationIndex < -1) return
		state.conversations[foundedConversationIndex] = conversation
		state.conversations = JSON.parse(JSON.stringify(state.conversations))

		if (state.selectedConversation.id === conversation.id) {
			state.selectedConversation = {...this.selectedConversation, ...conversation}
		}
	},
	setSelectedConversation: (state, conversation) => {
		state.selectedConversation = conversation
	},
	setConversations: (state, conversations) => {
		state.conversations = conversations.filter((conversation, index, self) =>
			index === self.findIndex((c) => (
				c.id === conversation.id
			))
		)
	},
	setMessages: (state, messages) => {
		state.messages = messages
	},
	setContacts: (state, contacts) => {
		state.contacts = contacts
	},
	setConversationStatusToTyping: (state, {conversation, user, status}) => {
		let foundedConversation = state.conversations.find(c => c.id === conversation.id)
		if (!foundedConversation) return
		foundedConversation.someoneIsWriting = status
		foundedConversation.currentWriter = user.name
		state.conversations = [...state.conversations]
	},
	setConversationMessagesAsRead: (state, {conversationId, user}) => {
		let foundedConversation = state.conversations.find(c => c.id === conversationId)
		if (!foundedConversation) return
		state.messages.map((message) => {
			if (message.conversationId === conversationId) {
				if (message.logs.find((log) => log.userId === user.userId)) return
				message.logs.push(user)
			}
		})
	}
}

const actions = {}

const getters = {
	messages: (state) => state.messages,
	contacts: (state) => state.contacts,
	conversations: (state) => state.conversations,
	selectedConversation: (state) => state.selectedConversation,
	selectedConversationUser: (state, getters, rootState) => {
		if (state.selectedConversation.type === 0) {
			return state.selectedConversation.participants.find(p => p.userId !== rootState.User.user.id)
		}
		return {}
	},
	selectedConversationTitle: (state, getters, rootState) => {
		if (state.selectedConversation.type === 0) {
			let participant = state.selectedConversation.participants.find(p => p.userId !== rootState.User.user.id)
			return `${participant.name} ${participant.surname}`
		}
		return state.selectedConversation.title
	},
	selectedConversationImage: (state, getters, rootState) => {
		if (state.selectedConversation.type === 0) {
			let participant = state.selectedConversation.participants.find(p => p.userId !== rootState.User.user.id)
			if (!participant.image && participant.genderId === 8) {
				return '/static/man-profile.png'
			} else if (!participant.image && participant.genderId === 9) {
				return '/static/woman-profile.png'
			} else {
				return uploadPath + participant.image
			}
		}
		return uploadPath + state.selectedConversation.imagePath
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/store/modules/Chat.js